import React from 'react'
import { useTranslation } from 'react-i18next'
import { IVoltLicenseData } from '@cbgms/api/support'
import { Checkbox, TableCell, TableRow } from '@mui/material'
import { Link } from '@carsys/ui'
import HaynesProDateSparkLine from './HaynesProDateSparkLine'
import Date from 'core/widgets/Date'
import { NullableDate } from './date.d'

interface IPropsLicenseTable {
  row: IVoltLicenseData
  startDate: NullableDate
  endDate: NullableDate
  selected: boolean
  setSelected: (selected: boolean) => void
}

const HaynesProLicensesTableRow: React.FC<IPropsLicenseTable> = ({ startDate, endDate, row, selected, setSelected }) => {
  const { t } = useTranslation()

  return (
    <TableRow key={row.LicenseID}>
      <TableCell padding='checkbox'>
        <Checkbox
          checked={selected}
          onChange={event => {
            setSelected(event.target.checked)
          }}
          color='primary'
        />
      </TableCell>
      <TableCell>
        {row.LicenseUUID ? (
          <Link to={`/companies/${row.CompanyUUID}/licenses/edit/${row.LicenseUUID}`}>{row.LicenseID}</Link>
        ) : (
          row.LicenseID
        )}
      </TableCell>
      <TableCell>
        {row.ProductType.ID}:{row.ProductType.Name} {row.ProductType.Code}
      </TableCell>
      <TableCell>{row.Customer?.ClientID}</TableCell>
      <TableCell>
        {row.Customer?.Reseller?.Name ? (
          <>
            {row.Customer?.Reseller?.Name} ({row.Customer?.Reseller?.ID})
          </>
        ) : (
          <>-</>
        )}
      </TableCell>
      <TableCell>
        <Link to={`/companies/${row.CompanyUUID}#licenses`}> {row.CompanyDetails}</Link>
      </TableCell>
      <TableCell>
        {row.IsCompanyLicense ? (
          t('haynespro.company_license_description')
        ) : (
          <Link to={`/companies/${row.CompanyUUID}/shops/edit/${row.ShopID}`}>{row.ShopDetails}</Link>
        )}
      </TableCell>
      <TableCell>
        <Date content={row.BeginDate} />
      </TableCell>
      <TableCell>
        <Date content={row.EndDate} />
      </TableCell>
      <TableCell style={{ overflow: 'hidden' }}>
        <HaynesProDateSparkLine startDate={startDate} endDate={endDate} licenseEndDate={row.EndDate} licenseStartDate={row.BeginDate} />
      </TableCell>
    </TableRow>
  )
}

export default HaynesProLicensesTableRow
